<template>
  <div>
    <div class="formulario">

      <div class="formulario_titulo"> 
        <h2> Gestión de Unidades Administrativas y Académicas </h2>
         <hr>
      </div>

      <div class="formulario_cuerpo">
                
        <table class="tabla" v-show="datos.length">
          <thead  >
            <tr class="tabla_cabecera">
              <th class="columnas_cabecera"  v-for="column in columns">
                {{column}}
              </th>
            </tr>
          </thead>
          
          <tbody  class="tabla_cuerpo">
            <tr v-for="(dato,index) in datos">
              <td>{{index +1}}</td>
              <td>{{dato.nombre_area}}</td>
              <td>{{dato.sgp_area}}</td>
              <td>{{dato.sgia_area}}</td>
              <td>{{dato.sieb_area}}</td>
              <td>{{dato.padre_area}}</td>
              <td>{{dato.tipo_area}}</td>
              <td>{{dato.ubicacion_area}}</td>
              <td>{{dato.alias_area}}</td>
              <td>{{dato.estado_area}}</td>
              <td>{{dato.representante_area}}</td>
              <td>{{dato.contacto_area}}</td>
              <td>{{dato.enlace_area}}</td>

              <td style="width: 10%;">
               
                <div class="botonEditar" @click="edit(index)"></div>
                <!-- <div class="botonEliminar" @click="archive(index)"></div> -->
              </td>
            </tr>
          </tbody>

        </table>
      </div>

      <div class="formulario_pie"> 
         <router-link class="atras" 
              v-bind:to="'/gestion'">
              <img class="atras" src="../assets/img/atras.svg"/>
        </router-link>
      </div>
    </div>
    
    <div id="modal" class="modal"  v-if="showModal">
       <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container container_grande">

          <div class="modal-header">
            <slot name="header">
              <h3>Actualizar Datos</h3>
            </slot>
          </div>

          <div class="modal-body body_grande">
            <slot name="body">
              <div class="row ">
                
                    <div class="campo">
                      <input placeholder="Nombre" id="nombreArea" type="text" v-model="editInput.nombreArea">
                      <label for="nombreArea">Nombre</label>
                    </div>
                    <div class="campo">
                      <input placeholder="SGP" id="sgpArea" type="text" v-model="editInput.sgpArea">
                      <label for="sgpArea">SGP Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="SIEB" id="siebArea" type="text" v-model="editInput.siebArea">
                      <label for="siebArea">SIEB Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="SGIA" id="sgiaArea" type="text" v-model="editInput.sgiaArea">
                      <label for="sgiaArea">SGIA Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="padre" id="padreArea" type="text" v-model="editInput.padreArea">
                      <label for="padreArea">Padre Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="tipo" id="tipoArea" type="text" v-model="editInput.tipoArea">
                      <label for="tipoArea">Tipo Área</label>
                    </div>
              </div>

              <div class="row">
                    <div class="campo">
                      <input placeholder="Ubicacion" id="ubicacionArea" type="text" v-model="editInput.ubicacionArea">
                      <label for="ubicacionArea">Ubicacion Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="Alias" id="aliasArea" type="text" v-model="editInput.aliasArea">
                      <label for="aliasArea">Alias Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="estado" id="estadoArea" type="text" v-model="editInput.estadoArea">
                      <label for="estadoArea">Estado Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="representante" id="representanteArea" type="text" v-model="editInput.representanteArea">
                      <label for="representanteArea">Representante Área</label>
                    </div>
                    <div class="campo">
                      <input placeholder="enlace" id="enlaceArea" type="text" v-model="editInput.enlaceArea">
                      <label for="enlaceArea">Enlace Área</label>
                    </div>
                </div>

            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
             
              <button class="modal-default-button" @click="update">
                Editar
              </button>
               <button class="modal-default-button" @click="showModal=false">
                Cancelar
              </button>
            </slot>
          </div>    
          </div> 
        </div>
      </div>
    </div>

    <div id="modal2" class="modal"  v-if="showModal2">
       <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3>Actualización de Datos</h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
                {{mensaje}}
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              
               <router-link class="atras" 
                v-bind:to="'/gestion/formularioArea'">
                  <button class="modal-default-button" @click="showModal2=false">
                    OK
                  </button>
               </router-link>
            </slot>
          </div>    
          </div> 
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import cabecera from '../components/cabecera.vue'
import pie from '../components/pie.vue'

import axios from 'axios'
import store from '../store'

export default {
  name: 'formularioArea',
  components: {
    cabecera, 
    pie, 
  },
   data() {
    return {
      area: '',
      areaEditada: '',
      datos: [],
      marcadores: [],
      columns: ['Indice', 'Nombre',  'SGP', 'SGIA', 'SIEB', 'Padre','Tipo','Ubicación','Alias', 'Estado','Representante','Contacto','Enlace', 'Opciones' ],
      input: {
        idArea:0,
        nombreArea: "Nuevo area",
        sgpArea:100,
        sgiaArea: 100,
        siebArea: 100,
        padreArea: 0,
        tipoArea: 1,
        ubicacionArea: 0,
        aliasArea: "Alias",
        estadoArea: 1,
        representanteArea: "Director",
        contactoArea: "telefono",
        enlaceArea: "espoch.edu.ec",
      },
      editInput: {
        idArea:0,
        nombreArea: "Nuevo area",
        sgpArea:100,
        sgiaArea: 100,
        siebArea: 100,
        padreArea: 0,
        tipoArea: 1,
        ubicacionArea: 0,
        aliasArea: "Alias",
        estadoArea: 1,
        representanteArea: "Director",
        contactoArea: "telefono",
        enlaceArea: "espoch.edu.ec",
      },
      showModal: false,
      showModal2: false
    }
  },
  methods: {
    consultaApi(opc) {
      this.datos.length = 0;
      axios.get('http://cimogsys.espoch.edu.ec:3000/api/'+ opc).then((response) => {
    //  axios.get('http://localhost:3000/api/'+ opc).then((response) => {
        this.datos = response.data.data;
        console.log(this.datos);
      });
    },
    //******************************implementar newva area resftul**********************//  
    add: function() {
      this.area="nombreArea="+this.input.nombreArea+
                "&sgiaArea="+this.input.sgiaArea+
                "&sgpArea="+this.input.sgpArea+
                "&siebArea="+this.input.siebArea+
                "&padreArea="+this.input.padreArea+
                "&tipoArea="+this.input.tipoArea+
                "&ubicacionArea="+this.input.ubicacionArea+
                "&aliasArea="+this.input.aliasArea+
                "&estadoArea="+this.input.estadoArea+
                "&representanteArea="+this.input.representanteArea+
                "&contactoArea="+this.input.contactoArea+
                "&enlaceArea="+this.input.enlaceArea;

      //axios.post('http://localhost:3000/api/new',this.area)
      axios.post('http://cimogsys.espoch.edu.ec:3000/api/new',this.area)
        .then(response => {
          this.showModal2=true;
          if(response=200){
            this.mensaje="Agregado correctamente";
            this.consultaApi("buildings");

          }
        })
        .catch(e => {
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Ingrese datos correctos";
        })
    },
    //function to handle data edition
    edit: function(index) {
      this.showModal=true;
      this.editInput.idArea=this.datos[index].id_area;
      this.editInput.nombreArea=this.datos[index].nombre_area;
      this.editInput.siebArea=this.datos[index].sieb_area;
      this.editInput.sgpArea=this.datos[index].sgp_area;
      this.editInput.sgiaArea=this.datos[index].sgia_area;
      this.editInput.padreArea=this.datos[index].padre_area;
      this.editInput.tipoArea=this.datos[index].tipo_area;
      this.editInput.ubicacionArea=this.datos[index].ubicacion_area;
      this.editInput.aliasArea=this.datos[index].alias_area;
      this.editInput.estadoArea=this.datos[index].estado_area;
      this.editInput.representanteArea=this.datos[index].representante_area;
      this.editInput.contactoArea=this.datos[index].contacto_area;
      this.editInput.enlaceArea=this.datos[index].enlace_area;
      console.log(this.editInput);
    },
    //******************************implementar newva area resftul**********************//  

    //function to update data
    update: function(){
      this.areaEditada="nombreArea="+this.editInput.nombreArea+
                    "&siebArea="+this.editInput.siebArea+
                    "&sgpArea="+this.editInput.sgpArea+
                    "&sgiaArea="+this.editInput.sgiaArea+
                    "&padreArea="+this.editInput.padreArea+
                    "&tipoArea="+this.editInput.tipoArea+
                    "&ubicacionArea="+this.editInput.ubicacionArea+
                    "&aliasArea="+this.editInput.aliasArea+
                    "&estadoArea="+this.editInput.estadoArea+
                    "&representanteArea="+this.editInput.representanteArea+
                    "&contactoArea="+this.editInput.contactoArea+
                    "&enlaceArea="+this.editInput.enlaceArea;
      //console.log(this.editInput);

      axios.put('http://cimogsys.espoch.edu.ec:3000/api/updateArea/'+this.editInput.idArea,this.areaEditada)
      //axios.put('http://localhost:3000/api/updateArea/'+this.editInput.idArea,this.areaEditada)
        .then(response => {
          console.log(response)
          this.showModal=false;
          this.showModal2=true;
          if(response=200){
            this.mensaje="Editado correctamente";
            this.consultaApi("areas");

          }
        })
        .catch(e => {
          this.showModal=false;
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Ingrese datos correctos";
        })
    },
     //function to send data to bin
    archive: function(index) {
      console.log(this.datos[index].id_area)
      axios.delete('http://cimogsys.espoch.edu.ec:3000/api/removeArea/'+ this.datos[index].id_area)
      //axios.delete('http://localhost:3000/api/removearea/'+ this.datos[index].id_area)
        .then(response => {
          console.log(response)
          this.showModal2=true;
          if(response=200){
            this.mensaje="Eliminado correctamente";
            this.consultaApi("buildings");

          }
        })
        .catch(e => {
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Elimine areas no relacionados con áreas";
        })
    },

  },
  mounted() {
   
    this.consultaApi("areas");
    
  }

}

var ordonner = function(a, b) {
  return (a.nombreArea > b.nombreArea);
};

(function() {
  //initialize modal box with jquery
  ('.modal').modal();
});


</script>

<style  lang="scss"  scoped src="../sass/formulario.scss"></style>



// WEBPACK FOOTER //
// src/components/formularioArea.vue